"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["data_space_id"];
const _hoisted_2 = {
    key: 0,
    class: "board-space-text"
};
const _hoisted_3 = {
    key: 2,
    class: "board-space-coords"
};
const _hoisted_4 = {
    key: 0,
    class: "gagarin"
};
const _hoisted_5 = {
    key: 1,
    class: "gagarin visited"
};
const _hoisted_6 = {
    key: 2,
    class: "board-cube--cathedral"
};
const _hoisted_7 = {
    key: 3,
    class: "board-cube--nomad"
};
const _hoisted_8 = {
    key: 6,
    class: "board-space-type-deflection-zone"
};
const _hoisted_9 = ["data_log_highlight_id"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_board_space_tile = (0, vue_1.resolveComponent)("board-space-tile");
    const _component_bonus = (0, vue_1.resolveComponent)("bonus");
    const _component_underground_token = (0, vue_1.resolveComponent)("underground-token");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return (_ctx.space !== undefined)
        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
            key: 0,
            class: (0, vue_1.normalizeClass)(_ctx.mainClass),
            data_space_id: _ctx.space.id
        }, [
            (0, vue_1.createVNode)(_component_board_space_tile, {
                space: _ctx.space,
                aresExtension: _ctx.aresExtension,
                tileView: _ctx.tileView
            }, null, 8, ["space", "aresExtension", "tileView"]),
            (_ctx.text)
                ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                    (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.text), 1)
                ])), [
                    [_directive_i18n]
                ])
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.showBonus)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_bonus, {
                    key: 1,
                    bonus: _ctx.space.bonus
                }, null, 8, ["bonus"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.tileView === 'coords')
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, (0, vue_1.toDisplayString)(_ctx.getSpaceName(_ctx.space.id)), 1))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.tileView === 'show')
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 3 }, [
                    (_ctx.space.color !== undefined)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            key: 0,
                            class: (0, vue_1.normalizeClass)(_ctx.playerColorCss)
                        }, null, 2))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.space.gagarin !== undefined)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 1 }, [
                            (_ctx.space.gagarin === 0)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4))
                                : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5))
                        ], 64))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.space.cathedral === true)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_6))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.space.nomads === true)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.claimedToken !== undefined)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_underground_token, {
                            key: 4,
                            token: _ctx.claimedToken,
                            location: "board"
                        }, null, 8, ["token"]))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.space.excavator !== undefined)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            key: 5,
                            class: (0, vue_1.normalizeClass)(["underground-excavator", 'underground-excavator--' + _ctx.space.excavator])
                        }, null, 2))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.space.spaceType === _ctx.SpaceType.DEFLECTION_ZONE)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_8))
                        : (0, vue_1.createCommentVNode)("", true)
                ], 64))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createElementVNode)("div", {
                class: "board-log-highlight",
                data_log_highlight_id: _ctx.space.id
            }, null, 8, _hoisted_9)
        ], 10, _hoisted_1))
        : (0, vue_1.createCommentVNode)("", true);
}
